/**
 * FeedbackSuccess — 불편/오류/건의사항 신고 접수 완료 카드
 */

import { cn } from '@/lib/utils';

interface FeedbackSuccessProps {
  ticketId: string;
}

export function FeedbackSuccess({ ticketId }: FeedbackSuccessProps) {
  return (
    <div
      className={cn(
        'ml-p-4 ml-rounded-cb-md',
        'ml-bg-gradient-to-br ml-from-brand-50 ml-to-white',
        'ml-border ml-border-brand-200'
      )}
    >
      <div className="ml-text-2xl ml-mb-2">✅</div>
      <div className="ml-text-cb-lg ml-font-semibold ml-text-brand-600 ml-mb-2">
        신고가 접수되었습니다
      </div>
      <div className="ml-text-cb-base ml-text-ink-secondary ml-mb-3 ml-whitespace-pre-line">
        담당자가 확인 후 회원 정보로 안내드리겠습니다.
        영업일 기준 1일 이내 답변드립니다.
      </div>
      <div
        className={cn(
          'ml-mt-3 ml-pt-3 ml-border-t ml-border-brand-200',
          'ml-flex ml-items-center ml-gap-2'
        )}
      >
        <span className="ml-text-cb-xs ml-text-mute">접수번호</span>
        <span className="ml-text-cb-sm ml-font-mono ml-font-semibold ml-text-brand-600">
          {ticketId}
        </span>
      </div>
    </div>
  );
}
